import { debounceTime, distinctUntilChanged, filter, fromEvent, map, skip } from 'rxjs';
import Carousel from '@components/carousel/dynamicCarousel';

const settings = {
    itemListQuerySelector: '[data-section-name="popularPills"] [data-popular-pills-list]',
    previousQuerySelector: '[data-section-name="popularPills"] [data-left-arrow]',
    nextQuerySelector: '[data-section-name="popularPills"] [data-right-arrow]',
};

/**
 * updatePopularPillContainerLeftPadding: Adjusts the padding of the popular pills container based on the visibility 
 * of the left arrow control in the specified popular pills section.
 * @param {HTMLElement} popularPillsSection - The main container element 
 *        representing the popular pills section. It should contain the arrows 
 *        and the pills container as its child elements.
 */
const updatePopularPillContainerLeftPadding = function(prevButtonVisibility, popularPillsSection) {
    const popularPillsContainer = popularPillsSection.querySelector('[data-popular-pills-container]');
    popularPillsContainer?.classList.toggle('padding-left--0', prevButtonVisibility === 'hidden');
    popularPillsContainer?.classList.toggle('padding-left--30', prevButtonVisibility === 'visible');
};

/**
 * updatePopularPillContainerRightPadding: Adjusts the padding of the popular pills container based on the visibility 
 * of the right arrow control in the specified popular pills section.
 * @param {HTMLElement} popularPillsSection - The main container element 
 *        representing the popular pills section. It should contain the arrows 
 *        and the pills container as its child elements.
 */
const updatePopularPillContainerRightPadding = function(nextButtonVisibility, popularPillsSection) {
    const popularPillsContainer = popularPillsSection.querySelector('[data-popular-pills-container]');
    popularPillsContainer?.classList.toggle('padding-right--0', nextButtonVisibility === 'hidden');

    if(nextButtonVisibility === 'visible'){
        const popularPillList = popularPillsSection.querySelector('[data-popular-pills-list]');
        popularPillList.scrollBy({ left: 28, behavior: 'smooth' });
    }
};

// listen for the DOMContentLoaded event to ensure the DOM is fully loaded before updating the popular pills.
const onDomContentLoaded$ = fromEvent(document, 'DOMContentLoaded').pipe(
    map(() => document.querySelector('[data-section-name="popularPills"]')),
    filter(Boolean)
);

onDomContentLoaded$.subscribe((popularPillsSection) => {
    const carousel = new Carousel();
    carousel.setSettings(settings);
    carousel.create();

    // debouce to get only last interaction on scroll animation
    const newVisibleElements$ = carousel.visibleElementsSubject$.pipe(debounceTime(200));
    newVisibleElements$.pipe(
        map(() => popularPillsSection.querySelector('[data-left-arrow]')?.style.visibility),
        filter(Boolean),
        distinctUntilChanged(),
        skip(1)
    ).subscribe((prevButtonVisibility) => 
        updatePopularPillContainerLeftPadding(prevButtonVisibility, popularPillsSection));

    newVisibleElements$.pipe(
        map(() => popularPillsSection.querySelector('[data-right-arrow]')?.style.visibility),
        filter(Boolean),
        distinctUntilChanged(),
        skip(1)
    ).subscribe((nextButtonVisibility) => 
        updatePopularPillContainerRightPadding(nextButtonVisibility, popularPillsSection));
});
